//Date Time formatting
import {getCompanyValByKey} from "@/helpers/companyHelper";
//import Vue from "vue";

export function getCurrency(){
    return getCompanyValByKey('currency');
}
export function getCurrencyFormattedVal(amount){
    return getCompanyValByKey('currency_prefix')? getCompanyValByKey('currency') + amount: amount + getCompanyValByKey('currency');
}